import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from "../services/loader.service";

// Injectable()

// export class LoaderInterceptor implements HttpInterceptor {
//   constructor(private loaderService: LoaderService) {}

//   intercept(
//     request: HttpRequest<unknown>,
//     next: HttpHandler
//   ): Observable<HttpEvent<unknown>> {
//     this.loaderService.showLoader();

//     return next.handle(request).pipe(
//       finalize(() => {
//         this.loaderService.hideLoader();
//       })
//     );
//   }
  
// }

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loadService = inject(LoaderService);
  loadService.showLoader();
  return next(req).pipe(    
    finalize(() => loadService.hideLoader())
  );
};
